import React from "react";
import cn from "classnames";

import { AdaptiveCover } from "@litres/ui-kit/cover";
import { useTranslation } from "@litres-libs/i18n";

import { SmartLink } from "@litres-modules/smart-link";
import type { SellableItemProps } from "../types";
import { SellableItemDetails } from "./SellableItemDetails/SellableItemDetails";
import { SellableItemActionBlock } from "./SellableItemActionBlock/SellableItemActionBlock";
import { trackerSpotlightClickItem } from "../utils";
import styles from "./SellableItem.module.scss";

export const SellableItem = (props: SellableItemProps): JSX.Element => {
  const {
    art,
    externalRef,
    isDesktop,
    eventData,
    isUserAnonymous,
    searchQuery,
    saveSearchQuery,
  } = props;

  const { id, url, title, cover_ratio } = art;

  const handleSearchItemClick = (): void => {
    if (!isUserAnonymous && searchQuery) {
      saveSearchQuery(searchQuery);
    }
  };

  const { t } = useTranslation();

  return (
    <li
      className={cn(styles.sellableItemWrapperAB, {
        [styles.mobileWrapper]: !isDesktop,
      })}
      key={url}
      ref={externalRef}
      onClick={(e: React.MouseEvent): void => {
        handleSearchItemClick();
        trackerSpotlightClickItem(eventData, e, url || "/");
      }}
      role="listitem"
      aria-label={t("Перейти")}
    >
      <SmartLink href={url || ""} className={styles.item} aria-label={title}>
        <div className={styles.coverContainer}>
          <span
            className={styles.coverWrapper}
            style={{ height: 56, width: 56 * (cover_ratio || 1) }}
          >
            <AdaptiveCover
              artId={id}
              alt={title}
              coverSizes={{
                desktopNormal: 70,
                desktopHighDensity: 120,
                mobileNormal: 70,
                mobileHighDensity: 120,
                byHeight: true,
              }}
              unloaderSize={20}
            />
          </span>
        </div>
        <SellableItemDetails {...art} />
        {isDesktop && (
          <SellableItemActionBlock art={art} eventData={eventData} />
        )}
      </SmartLink>
    </li>
  );
};
